export const IconAiSparkleMiniGradient = ({ size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.85851 1.00229C4.19872 0.0828962 5.49909 0.0828962 5.83929 1.00229L6.64736 3.18605C6.66316 3.22875 6.69683
       3.26243 6.73954 3.27823L8.9233 4.08629C9.84269 4.4265 9.84269 5.72687 8.9233 6.06708L6.73954 6.87514C6.69683 6.89095
        6.66316 6.92462 6.64736 6.96732L5.83929 9.15108C5.49909 10.0705 4.19872 10.0705 3.85851 9.15108L3.05045 6.96732C3.03464
         6.92462 3.00097 6.89094 2.95827 6.87514L0.774505 6.06708C-0.144887 5.72687 -0.144887 4.4265 0.774505 4.08629L2.95827
          3.27823C3.00097 3.26243 3.03464 3.22875 3.05045 3.18605L3.85851 1.00229ZM4.99523 1.31462C4.94496 1.17879 4.75284
           1.17879 4.70258 1.31462L3.89451 3.49838C3.78755 3.78744 3.55965 4.01534 3.2706 4.1223L1.08684 4.93036C0.951002
            4.98062 0.951002 5.17275 1.08684 5.22301L3.2706 6.03108C3.55965 6.13803 3.78755 6.36594 3.89451 6.65499L4.70258
             8.83875C4.75284 8.97459 4.94496 8.97459 4.99523 8.83875L5.80329 6.65499C5.91025 6.36594 6.13815 6.13803 6.42721
              6.03108L8.61097 5.22301C8.7468 5.17275 8.7468 4.98062 8.61097 4.93036L6.42721 4.1223C6.13815 4.01534 5.91025
               3.78744 5.80329 3.49838L4.99523 1.31462Z"
      fill="url(#paint0_linear_1481_6598)"
    />
    <path
      d="M9.68191 7.77943C9.77461 7.52893 10.1289 7.52893 10.2216 7.77943L10.6053 8.81625C10.6344 8.895 10.6965 8.9571
       10.7753 8.98624L11.8121 9.3699C12.0626 9.46259 12.0626 9.8169 11.8121 9.9096L10.7753 10.2933C10.6965 10.3224 10.6344
        10.3845 10.6053 10.4632L10.2216 11.5001C10.1289 11.7506 9.77461 11.7506 9.68191 11.5001L9.29825 10.4632C9.26911
         10.3845 9.20702 10.3224 9.12826 10.2933L8.09144 9.9096C7.84094 9.8169 7.84094 9.46259 8.09144 9.3699L9.12826
          8.98624C9.20702 8.9571 9.26911 8.895 9.29825 8.81625L9.68191 7.77943Z"
      fill="url(#paint1_linear_1481_6598)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1481_6598"
        x1="12"
        y1="6.03248"
        x2="0.0849615"
        y2="6.02987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0057FF" />
        <stop offset="1" stopColor="#A500C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1481_6598"
        x1="12"
        y1="6.03248"
        x2="0.0849615"
        y2="6.02987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0057FF" />
        <stop offset="1" stopColor="#A500C4" />
      </linearGradient>
    </defs>
  </svg>
)
